import React, { useEffect, useRef, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import "leaflet";
import * as styles from "./location.module.css";
import RightArrow from "../Assets/svg/right-arrow.svg";
// import "leaflet.markercluster";

// const L = window["L"];

// let DefaultIcon = L.icon({
//   iconRetinaUrl: "leaflet/dist/images/marker-icon-2x.png",
//   iconUrl: "leaflet/dist/images/marker-icon.png",
//   shadowUrl: "leaflet/dist/images/marker-shadow.png",
// });

// L.Marker.prototype.options.icon = DefaultIcon;

const locations = [
  {
    latitude: 12.9951,
    longitude: 74.8094,
    name: "Surathkal",
    event: "SIH",
  },
  {
    latitude: 30.7333,
    longitude: 76.7794,
    name: "Chandigarh",
    event: "I stay here",
  },
];

const Card = ({ data, handleClick }) => {
  return (
    <div className={styles.cardOuter}>
      <div className={styles.imageDiv}>
        <img src="/jaw.gif"></img>
      </div>
      <div className={styles.dataDiv}>
        <p
          onClick={
            handleClick
              ? () => handleClick(data.latitude, data.longitude)
              : undefined
          }
          className={styles.cardName}
        >
          {data.name}
        </p>
        <p>{data.event}</p>
      </div>
    </div>
  );
};

export default function MyMap() {
  const map = useRef();
  const [openSidebar, setOpenSidebar] = useState(true);

  const handleClick = (lat, long) => {
    map.current.flyTo([lat, long], 10, { duration: 2 });
  };

  return (
    <div className={styles.outer}>
      <div
        className={`${styles.sidebar} ${
          openSidebar ? "" : styles.sidebarClose
        }`}
      >
        <div className={styles.list}>
          {locations.map(value => (
            <Card data={value} handleClick={handleClick} />
          ))}
        </div>
        <button
          onClick={() => setOpenSidebar(prev => !prev)}
          className={styles.button}
        >
          <img
            src={RightArrow}
            className={`${styles.buttonImage} ${
              !openSidebar ? "" : styles.buttonImageRotate
            }`}
          />
        </button>
      </div>

      <div className={`${styles.map} ${openSidebar ? "" : styles.mapBig}`}>
        <MapContainer
          center={[30.7333, 76.7794]}
          zoom={4}
          scrollWheelZoom={false}
          whenCreated={mapi => (map.current = mapi)}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {locations.map(value => (
            <Marker position={[value.latitude, value.longitude]}>
              <Popup>
                <Card data={value} />
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
